// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"33907e0e","327":"481f2422","338":"1ab430a6","408":"1c1cd80a","495":"802b279f","672":"5daf9ff8","833":"d4ca37a8","872":"3086d4b5"}[chunkId] + ".chunk.js";
};